export type TtsMode = "browser" | "worker" | "off";

export interface AiConfig {
  /** Worker base URL. Empty => offline mock mode. */
  workerUrl: string;
  tts: TtsMode;
}

/**
 * Build-time config: VITE_AI_WORKER_URL, VITE_AI_TTS (browser|worker|off), VITE_AI_ENABLED=false to disable. `?ai=mock` forces mock.
 * Which characters get the AI chat is not configured here: every character with an `ai` block in the manifest does.
 */
export function aiConfig(env: Record<string, string | undefined>, search = ""): AiConfig | null {
  if (env.VITE_AI_ENABLED === "false") return null;
  const q = new URLSearchParams(search);
  const forceMock = q.get("ai") === "mock";
  const tts = (q.get("tts") ?? env.VITE_AI_TTS ?? "browser") as TtsMode;
  return {
    workerUrl: forceMock ? "" : (env.VITE_AI_WORKER_URL ?? "").replace(/\/$/, ""),
    tts: ["browser", "worker", "off"].includes(tts) ? tts : "browser"
  };
}
